import { useContext } from "react";
import { MdWhatshot } from "react-icons/md";
import { Grid } from "@mui/material";

import { purple } from "../config";
import { babyBlue } from "../config";
import { WebsocketContext } from "../contexts/websocketContext";
import useStreak from "../hooks/useStreak";
import Fade from "../components/Fade";

const StreakDisplay = () => {
  const { isMultiplayerHost } = useContext(WebsocketContext);
  const streak = useStreak();

  if (streak > 1 && !isMultiplayerHost) {
    return (
      <Fade delay={400}>
        <Grid
          container
          xs={12}
          alignItems="center"
          justifyContent="center"
          style={{
            marginTop: 0,
            fontFamily: "Bungee, Arial, Helvetica, sans-serif",
          }}
        >
          <MdWhatshot
            style={{
              color: babyBlue[300],
              fontSize: 24,
            }}
          />
          <span
            style={{
              margin: 0,
              textAlign: "left",
              color: babyBlue[300],
              padding: 3,
              display: "flex",
              alignItems: "center",
            }}
          >
            Streak
          </span>
          <div
            style={{
              padding: 13,
              borderRadius: 15,
              marginLeft: 5,
              display: "inline-block",
              position: "relative",
              backgroundColor: babyBlue[300],
              color: purple[500],
              lineHeight: "1.1",
            }}
          >
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              {streak}
            </span>
          </div>
        </Grid>
      </Fade>
    );
  } else {
    return null;
  }
};

export default StreakDisplay;
